import React from 'react';

/** Compact stroke icons for admin sidebar (24×24 viewBox). */
const Icon = ({ children }) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true">
    {children}
  </svg>
);

const stroke = {
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
};

const ICONS = {
  dashboard: (
    <Icon>
      <rect x="3" y="3" width="7" height="7" rx="1" {...stroke} />
      <rect x="14" y="3" width="7" height="7" rx="1" {...stroke} />
      <rect x="3" y="14" width="7" height="7" rx="1" {...stroke} />
      <rect x="14" y="14" width="7" height="7" rx="1" {...stroke} />
    </Icon>
  ),
  brands: (
    <Icon>
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z" {...stroke} />
      <circle cx="7" cy="7" r="1.25" fill="currentColor" />
    </Icon>
  ),
  salons: (
    <Icon>
      <path d="M3 21h18M5 21V8l7-4 7 4v13M9 21v-6h6v6" {...stroke} />
    </Icon>
  ),
  mirrors: (
    <Icon>
      <rect x="4" y="3" width="16" height="18" rx="2" {...stroke} />
      <path d="M8 8h8M8 12h5" {...stroke} />
    </Icon>
  ),
  categories: (
    <Icon>
      <path d="M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V7z" {...stroke} />
    </Icon>
  ),
  services: (
    <Icon>
      <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z" {...stroke} />
    </Icon>
  ),
  stylists: (
    <Icon>
      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" {...stroke} />
      <circle cx="12" cy="7" r="4" {...stroke} />
    </Icon>
  ),
  users: (
    <Icon>
      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" {...stroke} />
      <circle cx="9" cy="7" r="4" {...stroke} />
      <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" {...stroke} />
    </Icon>
  ),
  transactions: (
    <Icon>
      <rect x="2" y="5" width="20" height="14" rx="2" {...stroke} />
      <path d="M2 10h20" {...stroke} />
    </Icon>
  ),
  'ongoing-services': (
    <Icon>
      <circle cx="12" cy="12" r="9" {...stroke} />
      <path d="M12 7v5l3 2" {...stroke} />
    </Icon>
  ),
  reports: (
    <Icon>
      <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" {...stroke} />
      <path d="M9 5a2 2 0 012-2h2a2 2 0 012 2v0a2 2 0 01-2 2h-2a2 2 0 01-2-2v0zM9 12h6M9 16h4" {...stroke} />
    </Icon>
  ),
  feedback: (
    <Icon>
      <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2v10z" {...stroke} />
    </Icon>
  ),
  feeds: (
    <Icon>
      <rect x="2" y="4" width="20" height="14" rx="2" {...stroke} />
      <path d="M8 21h8M12 18v3" {...stroke} />
    </Icon>
  ),
  'promotional-feeds': (
    <Icon>
      <rect x="3" y="5" width="18" height="12" rx="2" {...stroke} />
      <path d="M10 9l5 3-5 3V9z" {...stroke} />
    </Icon>
  ),
  'engagement-services': (
    <Icon>
      <circle cx="12" cy="12" r="9" {...stroke} />
      <path d="M10 8l6 4-6 4V8z" {...stroke} />
    </Icon>
  )
};

export const getAdminNavIcon = (menuKey) => ICONS[menuKey] || ICONS.dashboard;

export default ICONS;
